export interface Message {
  id: number;
  role: 'user' | 'model';
  text: string;
}

export enum Sender {
  User = 'user',
  AI = 'ai',
  University = 'university',
}

export interface Attachment {
  name: string;
  type: string;
  url: string;
  size: number;
}

export interface ChatMessage {
    id: string;
    text: string;
    sender: Sender;
    attachments?: Attachment[];
    dbMessageId?: string; // Database message ID for feedback
    extensiveSearch?: boolean; // Whether extensive search was used for this message
}

export interface Chat {
    id: string;
    title: string;
    date: string;
}

export enum ModalType {
    Invite = 'invite',
    Feedback = 'feedback',
    Bug = 'bug',
    BookCall = 'bookCall',
    ChangePassword = 'changePassword',
    ContactUniversity = 'contactUniversity',
    ContactTTO = 'contactTTO',
    ConciergeRequest = 'conciergeRequest',
    PreviewMessage = 'previewMessage',
    SentMessage = 'sentMessage',
    DeleteAccount = 'deleteAccount',
}

export interface Invitee {
    id: number;
    email: string;
    firstName: string;
    lastName: string;
    orgName: string;
    linkedin: string;
}

export interface ProfileData {
  email: string;
  firstName: string;
  lastName: string;
  contactNumber: string;
  countryCode: string;
  country: string;
  city: string;
  companyName: string;
  designation: string;
  companyWebsite: string;
  qualification: string;
  linkedin: string;
  summary: string;
  hats: string[];
  intent: string[];
  profileImage?: string;
  referredByFirstName?: string;
  referredByLastName?: string;
  referredByEmail?: string;
}

// export interface RDProfileData {
//   collaborationTypes: string[];
//   collaborationLead: string[];
//   collaborationTimeline: string;
//   rdBudget: string;
//   otherInfo: string;
//   corporateDeckUrl: string;
//   rdSummary: string;
//   corporateDeckFile: string;
//   companyLinkedinPage?: string;
// }

export interface InterestsData {
  keywords: string[];
  emailAlerts: boolean;
}

export enum SavedCardType {
  All = 'all',
  Tech = 'tech',
  Researcher = 'researcher',
}

export interface SavedItem {
  id: string;
  type: SavedCardType.Tech | SavedCardType.Researcher;
  relevance: number | string; // Can be number (old format) or string (saved date)
  title: string;
  location: string;
  detail: string; // "5 Research cards" or "TRL 5"
  verified: boolean;
  showStatusIcon?: boolean;
  rawData?: any; // Store raw backend data for modal functionality
}

export enum MessageStatus {
    Delivered = 'delivered',
    Read = 'read',
}

export interface InboxMessageItem {
    id: string;
    sender: Sender;
    content: string;
    timestamp: string;
    status: MessageStatus;
    attachments?: Attachment[];
}

export interface InboxConversation {
    id: string;
    contactName: string;
    contactAffiliation: string;
    lastMessageTimestamp: string;
    messagePreview: string;
    techCardId: string;
    techCardTitle: string;
    subject?: string; // Original email subject for replies
    messages: InboxMessageItem[];
    participantEmail?: string; // Email address for replies
    participantName?: string; // Display name for participant
    status?: string; // Conversation status
}

export interface AttachedFile {
  id: string;
  file: File;
  status: 'success' | 'error' | 'loading';
  error?: string;
  previewUrl?: string;
}